import { useEffect } from "react";
import "./FloatingSocial.css"
const FloatingSocial = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.async = true;
    script.src =
      "https://cdn.bitrix24.com/b13599703/crm/site_button/loader_3_0f75a3.js?" +
      (Date.now() / 60000 | 0);
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return;
};

export default FloatingSocial;
